import { render, staticRenderFns } from "./Magnify.vue?vue&type=template&id=5cd9e566&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Magnify.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Magnify.vue
// module id = 2422
// module chunks = 1